
import React, { useEffect, useState } from "react";
import { FiEye, FiDownload, FiUpload } from "react-icons/fi";
import "./Docu.css";
import { UpdateStudentDocument } from "../../../api/StudentServices";
import { closeModal, ToastMain ,SweetAlertShow} from "../../master/Master";
import { imgBaseUrl } from "../../../api/api";
import BaseForm from "../../Documents/Form";
import { studentDetails } from "../../../api/Student";

const AdmissionForm = ({ data }) => {
  const [school, setSchool] = useState({});
  const [Data, setData] = useState('');
  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
  const student = data?.student || {};
  const courseInfo = student?.course_and_fees?.[0] || {};
  const [selectedCategory, setSelectedCategory] = useState('student')
  const[loading, setLoading]=useState(false)

  const getStudent = async () => {
     setLoading(true);
    try {
      const response = await studentDetails(`id=${student.id}`);
      if (response.data) {
        setData(response?.data);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
       
      }

    } catch (error) {
      SweetAlertShow("error",'Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
  
    } finally {
       setLoading(false);
    }
  };
  useEffect(() => {
    getStudent();
  }, [])
  const documents = data?.student?.documents || {};
  const handleDownload = async (url, filename) => {
    try {
      // ⚡ Fetch file as blob
      const response = await fetch(url, { mode: "no-cors" }); // no-cors lagaya
      const blob = await response.blob();

      // ⚡ Create temporary link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed!");
    }
  };





  // ✅ Print Handler
  const handlePrint = () => {
    const printContent = document.getElementById("admissionForm").innerHTML;
    const WinPrint = window.open("", "", "width=900,height=650");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Admission Form</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { font-family: Arial, sans-serif; background: #fff; color: #000; }
            .a4-sheet { width: 210mm; min-height: 297mm; margin: auto; padding: 20mm; border: 2px solid #000; background: #fff; }
            .form-header { text-align: center; margin-bottom: 20px; }
            .form-header img { height: 80px; margin-bottom: 10px; }
            .form-title { font-size: 22px; font-weight: bold; text-decoration: underline; }
            .section-title { font-weight: bold; margin: 25px 0 15px 0; background: #f1f1f1; padding: 8px 10px; border-left: 4px solid #7306c6; }
            .signature-box { border-top: 1px solid #000; margin-top: 60px; padding-top: 10px; text-align: center; }
            .underline-field { display:inline-block; border-bottom:1px dotted #000; min-width:200px; padding:0 4px; }
            @media print { body { -webkit-print-color-adjust: exact; } .a4-sheet { border: none; margin: 0; padding: 10mm; } }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.print();
  };

  // ✅ Document list define
  const docList = [
    { key: "aadhar", label: "Aadhar Card" },
    { key: "passport_photo", label: "Passport Photo" },
    { key: "last_year_marsit_1", label: "Last Year Marksheet 1" },
    { key: "last_year_marsit_2", label: "Last Year Marksheet 2" },
    { key: "signature", label: "Signature" },
  ];

  const UpdateDocument = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const dataObj = Object.fromEntries(formData.entries());

      // if (selectedImage) {
      //   formData.append("studentImage", selectedImage); // Append whichever was selected
      // }

      const response = await UpdateStudentDocument(formData);
      e.target.reset();

      if (response.data.status) {
        closeModal("editUser");

        ToastMain.fire({
          icon: "success",
          title: "updated successfully!",
        }).then(() => {
          getStudent();
          window.location.reload()
        })

      }
    } catch (error) {

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
   
    }
  };
  // ✅ Safe function to join baseURL + path



  return (
    <div>
      {/* Print Button */}
      <div className="mb-3 text-end">
        <button className="btn btn-primary btn-sm" onClick={handlePrint}>
          🖨 Print
        </button>
      </div>

      {/* =================== Admission Form =================== */}
      <div id="admissionForm" className="container my-4">
        <div
          className="card shadow-lg rounded-2xl p-4"
          style={{ maxWidth: "800px", margin: "0 auto", fontSize: "14px" }}
        >
          {/* Header */}
          <div className="text-center border-b pb-3 mb-3">
            <img
              src={
                instituteData?.logo_img
                  ? `${imgBaseUrl+instituteData.logo_img}`
                  : "/files/logo.png"
              }
              alt="Logo"
              style={{ height: "60px" }}
            />
            <h4 className="mt-2">{instituteData?.name || "School Name"}</h4>
            <p className="mb-1">
              <strong>Address:</strong>{" "}
              <span>
                {instituteData?.village},{" "}
                {instituteData?.district} ({instituteData?.state})
              </span>
            </p>
            <p className="mb-0">
              <strong>Phone:</strong>{" "}
              <span>{instituteData?.mobile}</span>{" "}
              {instituteData?.secondary_mobile && (
                <span>, {instituteData.secondary_mobile}</span>
              )}
              {" | "}
              <strong>Email:</strong>{" "}
              <span>{instituteData?.email}</span>
            </p>
            <div className="fw-bold text-lg mt-2">Admission Form</div>
          </div>

          {/* Student Info */}
          <div className="fw-bold border-bottom mb-2 text-primary">Student Information</div>
          <div className="row mb-2">
            <div className="col-6">
              Full Name:{" "}
              <span className="underline-field">{student.name}</span>
            </div>
            <div className="col-6">
              Father&apos;s Name:{" "}
              <span className="underline-field">{student.father_name}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              Mother&apos;s Name:{" "}
              <span className="underline-field">{student.mother_name}</span>
            </div>
            <div className="col-6">
              Date of Birth:{" "}
              <span className="underline-field">{student.dob}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              Gender: <span className="underline-field">{student.gender}</span>
            </div>
            <div className="col-6">
              Category:{" "}
              <span className="underline-field">{student.category}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12">
              Address:{" "}
              <span className="underline-field" style={{ minWidth: "400px" }}>
                {`${student.village || ""}, ${student.district || ""
                  }, ${student.state || ""} - ${student.zipcode || ""}`}
              </span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              Mobile No:{" "}
              <span className="underline-field">{student.phone}</span>
            </div>
            <div className="col-6">
              Aadhar No:{" "}
              <span className="underline-field">{student.aadhar}</span>
            </div>
          </div>

          {/* Course Info */}
          <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Course Information</div>
          <div className="row mb-2">
            <div className="col-6">
              Class Applied For:{" "}
              <span className="underline-field">
                {courseInfo?.course?.title || ""}
              </span>
            </div>
            <div className="col-6">
              Batch Timing:{" "}
              <span className="underline-field">
                {courseInfo?.batch?.start_time || ""} -{" "}
                {courseInfo?.batch?.end_time || ""}
              </span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              Date of Admission:{" "}
              <span className="underline-field">{courseInfo.admission_date}</span>
            </div>
            <div className="col-6">
              Admission No:{" "}
              <span className="underline-field">{student.registration_no}</span>
            </div>
          </div>

          {/* Transport Info */}
          <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Transport Details</div>
          <div className="row mb-2">
            <div className="col-6">
              Transport Facility Required:{" "}
              <span className="underline-field">
                {courseInfo.bus ? "Yes ☑" : "No ☑"}
              </span>
            </div>
            <div className="col-6">
              Route No:{" "}
              <span className="underline-field">
                {courseInfo.route?.route_name || ""}
              </span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12">
              Pickup Point:{" "}
              <span className="underline-field" style={{ minWidth: "300px" }}>
                {courseInfo.route?.pickup_point || ""}
              </span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12">
              Parent Contact:{" "}
              <span className="underline-field">{student.secondary_mobile}</span>
            </div>
          </div>

          {/* Declaration */}
          <div className="fw-bold border-bottom mt-3 mb-2 text-primary">Declaration</div>
          <p style={{ fontSize: "13px" }}>
            I hereby declare that the above information is true and correct to
            the best of my knowledge. I agree to abide by the rules and
            regulations of{" "}
            <span className="underline-field">
              {instituteData?.name}
            </span>
            .
          </p>

          {/* Signatures */}
          <div className="row mt-4 text-center">
            <div className="col-4 border-top pt-2">Student’s Signature</div>
            <div className="col-4 border-top pt-2">Parent’s Signature</div>
            <div className="col-4 border-top pt-2">Authorized Signatory</div>
          </div>
        </div>
      </div>

      {/* =================== Student Documents Section =================== */}
     

      <div className="modal fade" id="editUserold" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-simple modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="text-center mb-6">
                <h4 className="mb-2">Upload Student Documents</h4>
                {/* <p className="mb-6">
                  Updating user details will receive a privacy audit.
                </p> */}
              </div>
              {/* <form
                                            id="editUserForm"
                                            className="row g-5 fv-plugins-bootstrap5 fv-plugins-framework"
                                            onsubmit="return false"
                                            noValidate="novalidate"
                                        >
                                            <div className="col-12 col-md-6 fv-plugins-icon-container">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        id="modalEditUserFirstName"
                                                        name="modalEditUserFirstName"
                                                        className="form-control"
                                                        defaultValue="Oliver"
                                                        placeholder="Oliver"
                                                    />
                                                    <label htmlFor="modalEditUserFirstName">First Name</label>
                                                </div>
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                                            </div>
                                            <div className="col-12 col-md-6 fv-plugins-icon-container">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        id="modalEditUserLastName"
                                                        name="modalEditUserLastName"
                                                        className="form-control"
                                                        defaultValue="Queen"
                                                        placeholder="Queen"
                                                    />
                                                    <label htmlFor="modalEditUserLastName">Last Name</label>
                                                </div>
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                                            </div>
                                            <div className="col-12 fv-plugins-icon-container">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        id="modalEditUserName"
                                                        name="modalEditUserName"
                                                        className="form-control"
                                                        defaultValue="oliver.queen"
                                                        placeholder="oliver.queen"
                                                    />
                                                    <label htmlFor="modalEditUserName">Username</label>
                                                </div>
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        id="modalEditUserEmail"
                                                        name="modalEditUserEmail"
                                                        className="form-control"
                                                        defaultValue="oliverqueen@gmail.com"
                                                        placeholder="oliverqueen@gmail.com"
                                                    />
                                                    <label htmlFor="modalEditUserEmail">Email</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-floating form-floating-outline">
                                                    <select
                                                        id="modalEditUserStatus"
                                                        name="modalEditUserStatus"
                                                        className="form-select"
                                                        aria-label="Default select example"
                                                    >
                                                        <option value={1} selected="">
                                                            Active
                                                        </option>
                                                        <option value={2}>Inactive</option>
                                                        <option value={3}>Suspended</option>
                                                    </select>
                                                    <label htmlFor="modalEditUserStatus">Status</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-floating form-floating-outline">
                                                    <input
                                                        type="text"
                                                        id="modalEditTaxID"
                                                        name="modalEditTaxID"
                                                        className="form-control modal-edit-tax-id"
                                                        placeholder="123 456 7890"
                                                    />
                                                    <label htmlFor="modalEditTaxID">Tax ID</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="input-group input-group-merge">
                                                    <span className="input-group-text">US (+1)</span>
                                                    <div className="form-floating form-floating-outline">
                                                        <input
                                                            type="text"
                                                            id="modalEditUserPhone"
                                                            name="modalEditUserPhone"
                                                            className="form-control phone-number-mask"
                                                            defaultValue="+1 609 933 4422"
                                                            placeholder="+1 609 933 4422"
                                                        />
                                                        <label htmlFor="modalEditUserPhone">Phone Number</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-floating form-floating-outline form-floating-select2">
                                                    <div className="position-relative">
                                                        <select
                                                            id="modalEditUserLanguage"
                                                            name="modalEditUserLanguage"
                                                            className="select2 form-select select2-hidden-accessible"
                                                            multiple=""
                                                            data-select2-id="modalEditUserLanguage"
                                                            tabIndex={-1}
                                                            aria-hidden="true"
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="english" selected="" data-select2-id={2}>
                                                                English
                                                            </option>
                                                            <option value="spanish">Spanish</option>
                                                            <option value="french">French</option>
                                                            <option value="german">German</option>
                                                            <option value="dutch">Dutch</option>
                                                            <option value="hebrew">Hebrew</option>
                                                            <option value="sanskrit">Sanskrit</option>
                                                            <option value="hindi">Hindi</option>
                                                        </select>
                                                        <span
                                                            className="select2 select2-container select2-container--default"
                                                            dir="ltr"
                                                            data-select2-id={1}
                                                            style={{ width: "auto" }}
                                                        >
                                                            <span className="selection">
                                                                <span
                                                                    className="select2-selection select2-selection--multiple"
                                                                    role="combobox"
                                                                    aria-haspopup="true"
                                                                    aria-expanded="false"
                                                                    tabIndex={-1}
                                                                    aria-disabled="false"
                                                                >
                                                                    <ul className="select2-selection__rendered">
                                                                        <li
                                                                            className="select2-selection__choice"
                                                                            title="English"
                                                                            data-select2-id={3}
                                                                        >
                                                                            <span
                                                                                className="select2-selection__choice__remove"
                                                                                role="presentation"
                                                                            >
                                                                                ×
                                                                            </span>
                                                                            English
                                                                        </li>
                                                                        <li className="select2-search select2-search--inline">
                                                                            <input
                                                                                className="select2-search__field"
                                                                                type="search"
                                                                                tabIndex={0}
                                                                                autoComplete="off"
                                                                                autoCorrect="off"
                                                                                autoCapitalize="none"
                                                                                spellCheck="false"
                                                                                role="searchbox"
                                                                                aria-autocomplete="list"
                                                                                placeholder=""
                                                                                style={{ width: "0.75em" }}
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </span>
                                                            </span>
                                                            <span className="dropdown-wrapper" aria-hidden="true" />
                                                        </span>
                                                    </div>
                                                    <label htmlFor="modalEditUserLanguage">Language</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-floating form-floating-outline form-floating-select2">
                                                    <div className="position-relative">
                                                        <select
                                                            id="modalEditUserCountry"
                                                            name="modalEditUserCountry"
                                                            className="select2 form-select select2-hidden-accessible"
                                                            data-allow-clear="true"
                                                            data-select2-id="modalEditUserCountry"
                                                            tabIndex={-1}
                                                            aria-hidden="true"
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Australia">Australia</option>
                                                            <option value="Bangladesh">Bangladesh</option>
                                                            <option value="Belarus">Belarus</option>
                                                            <option value="Brazil">Brazil</option>
                                                            <option value="Canada">Canada</option>
                                                            <option value="China">China</option>
                                                            <option value="France">France</option>
                                                            <option value="Germany">Germany</option>
                                                            <option value="India" selected="" data-select2-id={5}>
                                                                India
                                                            </option>
                                                            <option value="Indonesia">Indonesia</option>
                                                            <option value="Israel">Israel</option>
                                                            <option value="Italy">Italy</option>
                                                            <option value="Japan">Japan</option>
                                                            <option value="Korea">Korea, Republic of</option>
                                                            <option value="Mexico">Mexico</option>
                                                            <option value="Philippines">Philippines</option>
                                                            <option value="Russia">Russian Federation</option>
                                                            <option value="South Africa">South Africa</option>
                                                            <option value="Thailand">Thailand</option>
                                                            <option value="Turkey">Turkey</option>
                                                            <option value="Ukraine">Ukraine</option>
                                                            <option value="United Arab Emirates">
                                                                United Arab Emirates
                                                            </option>
                                                            <option value="United Kingdom">United Kingdom</option>
                                                            <option value="United States">United States</option>
                                                        </select>
                                                        <span
                                                            className="select2 select2-container select2-container--default"
                                                            dir="ltr"
                                                            data-select2-id={4}
                                                            style={{ width: "auto" }}
                                                        >
                                                            <span className="selection">
                                                                <span
                                                                    className="select2-selection select2-selection--single"
                                                                    role="combobox"
                                                                    aria-haspopup="true"
                                                                    aria-expanded="false"
                                                                    tabIndex={0}
                                                                    aria-disabled="false"
                                                                    aria-labelledby="select2-modalEditUserCountry-container"
                                                                >
                                                                    <span
                                                                        className="select2-selection__rendered"
                                                                        id="select2-modalEditUserCountry-container"
                                                                        role="textbox"
                                                                        aria-readonly="true"
                                                                        title="India"
                                                                    >
                                                                        <span
                                                                            className="select2-selection__clear"
                                                                            title="Remove all items"
                                                                            data-select2-id={6}
                                                                        >
                                                                            ×
                                                                        </span>
                                                                        India
                                                                    </span>
                                                                    <span
                                                                        className="select2-selection__arrow"
                                                                        role="presentation"
                                                                    >
                                                                        <b role="presentation" />
                                                                    </span>
                                                                </span>
                                                            </span>
                                                            <span className="dropdown-wrapper" aria-hidden="true" />
                                                        </span>
                                                    </div>
                                                    <label htmlFor="modalEditUserCountry">Country</label>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="form-check form-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="editBillingAddress"
                                                    />
                                                    <label htmlFor="editBillingAddress" className="text-heading">
                                                        Use as a billing address?
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-12 text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary me-3 waves-effect waves-light"
                                                >
                                                    Submit
                                                </button>
                                                <button
                                                    type="reset"
                                                    className="btn btn-outline-secondary waves-effect"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <input type="hidden" />
                                        </form> */}

              <form id="editUserForm"
                className="row g-5 fv-plugins-bootstrap5 fv-plugins-framework"
                onsubmit="return false"
                noValidate="novalidate" onSubmit={UpdateDocument}>
                <div className="row">
                  <input type="hidden" name="student_id" value={student?.id} />
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      className="form-control"
                      type="file"
                      name="aadhar"
                    />
                    <label className=""> Aadhar </label>
                  </div>

                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="file"
                      className="form-control"
                      name="passport_photo"
                    />
                    <label className=""> Photo </label>
                  </div>

                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="file"
                      className="form-control"
                      name="last_year_marsit_1"
                    />
                    <label className=""> last_year_marsit_1 </label>
                  </div>

                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="file"
                      className="form-control"
                      name="last_year_marsit_2"
                    />
                    <label className=""> last_year_marsit_2 </label>
                  </div>

                  <div className="mb-3 col-md-12 form-floating form-floating-outline">
                    <input
                      type="file"
                      className="form-control"
                      name="signature"
                    />
                    <label className=""> signature </label>
                  </div>
                </div>
                <div className="d-flex text-end gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


       <div className="modal fade" id="editUser" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-lg modal-simple modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="text-center mb-6">
                <h4 className="mb-2">Upload Student Documents</h4>
                {/* <p className="mb-6">
                  Updating user details will receive a privacy audit.
                </p> */}
              </div>
            
<BaseForm defaultCategory={selectedCategory} StudentId={student?.id}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionForm;
